<p>{{ 'DIPRSRegistration.expiration.modal.introduction' | translate }}</p>
<p aria-live="polite">
  [<span>{{ minutes }}</span>:<span>{{ seconds }}</span>]
</p>
<div class="row td-toolbar">
  <div class="col-sm-6 mx-auto">
    <button type="button" class="btn btn-block td-btn-primary-light" (click)="resume()">
      {{ 'DIPRSRegistration.expiration.modal.resume' | translate }}
    </button>
  </div>
</div>
